import CustomModal from '@islands/custom-modal';
import { openCompareOffcanvas, closeCompareOffcanvas } from '@islands/compare-panel';
export default class CompareDrawer extends window.HTMLElement {
  modal: CustomModal | null = null;
  toggleBtn: HTMLElement | null = null;

  dialog: HTMLDialogElement | null = null;
  overlay: HTMLDivElement | null = null;
  panel: HTMLDivElement | null = null;

  constructor() {
    super();
    this.modal = document.querySelector('compare-drawer') as CustomModal;
    this.dialog = this.modal.querySelector('dialog');
    this.toggleBtn = this.querySelector('#compare-drawer');
    this.overlay = this.querySelector('#compare-drawer-overlay');
    this.panel = this.querySelector('#compare-drawer-panel');
    const closeBtns = this.querySelectorAll('[data-compare-drawer-close]');

    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (target.closest('.open-compare-btn')) {
        e.preventDefault();
        this.modal?.show();
        openCompareOffcanvas();
        return;
      }

      const addToCartBtn = target.closest('[data-add-to-cart]');
      if (addToCartBtn) {
        this.close();
        return;
      }

      if (target.closest('#close-compare-offcanvas') || target.id === 'compare-backdrop') {
        closeCompareOffcanvas();
      }
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.close();
        closeCompareOffcanvas();
      });
    });

    this.overlay?.addEventListener('click', () => {
      this.close();
      closeCompareOffcanvas();
    });

    // Intercept native Escape close
    this.dialog?.addEventListener('cancel', (e) => {
      e.preventDefault(); // stop auto-close
      this.close(); // use animated version
      closeCompareOffcanvas();
    });
  }

  show() {
    window.scrollLock();
    this.dialog?.showModal();
    this.panel?.classList.remove('translate-x-full');
    this.panel?.classList.add('translate-x-0');
  }

  close() {
    window.scrollUnlock();
    this.panel?.classList.remove('translate-x-0');
    this.panel?.classList.add('translate-x-full');

    setTimeout(() => {
      this.dialog?.close();
    }, 300);
  }
}

if (!customElements.get('compare-drawer')) {
  window.customElements.define('compare-drawer', CompareDrawer);
}
